import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/home/Home';
import Products from './pages/products/Products';
import ProductDetail from './pages/products/ProductDetail';
import Services from './pages/services/Services';
import BackOffice from './pages/services/BackOffice';
import Contact from './pages/contact/Contact';
import Pricing from './pages/pricing/Pricing';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Landing from './pages/landing/Landing';
import DocsHome from './pages/docs/DocsHome';
import CimmplePayDocsHome from './pages/docs/cimmplepay/CimmplePayDocsHome';
import CimmplePayGettingStarted from './pages/docs/cimmplepay/GettingStarted';
import CimmplePayAuthentication from './pages/docs/cimmplepay/Authentication';
import CimmplePayCoreFlows from './pages/docs/cimmplepay/CoreFlows';
import CimmplePayApiQuickReference from './pages/docs/cimmplepay/ApiQuickReference';
import CimmplePayGoLiveChecklist from './pages/docs/cimmplepay/GoLiveChecklist';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navigation />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:productId" element={<ProductDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/back-office" element={<BackOffice />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/lp" element={<Landing />} />
          <Route path="/docs" element={<DocsHome />} />
          <Route path="/docs/cimmplepay" element={<CimmplePayDocsHome />} />
          <Route path="/docs/cimmplepay/getting-started" element={<CimmplePayGettingStarted />} />
          <Route path="/docs/cimmplepay/authentication" element={<CimmplePayAuthentication />} />
          <Route path="/docs/cimmplepay/core-flows" element={<CimmplePayCoreFlows />} />
          <Route path="/docs/cimmplepay/api-quick-reference" element={<CimmplePayApiQuickReference />} />
          <Route path="/docs/cimmplepay/go-live-checklist" element={<CimmplePayGoLiveChecklist />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;

